import { CartMenuItem } from "custom-types/Cart";

export const transparentPixel =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

const getMenuItemImage = ({
  menuItemData: data,
}: {
  menuItemData: CartMenuItem;
}) => {
  if (!data || (!data.imageUrl && !data.productImageUrl)) {
    return transparentPixel;
  }
  return data.imageUrl || data.productImageUrl;
};

export default getMenuItemImage;
